import React, { memo, useCallback, useState } from "react";

import { generateKey } from "../../../../../../helpers/generate-unique-key";
import { TableColumn, TableRowAction } from "../../models";
import { TooltipDirection } from "../../enums";
import { TableCell } from "../table-cell";
import TableRow from "../table-row";

interface TableBodyProps {
  rowKey?: string;
  rowClicked: boolean;
  rowClickedKey: string;
  columns: Array<TableColumn>;
  rows: Array<Record<string, any>>;
  totals?: Record<string, React.ReactNode>;
  onRowClick: (row: any, index: number) => void;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
  getNestedTableData?: (row: any, index: number) => void;
  getRowActions?: (row: any, index: number) => Array<TableRowAction>;
  renderRowNestedChildren?: (row: Record<string, any>, index: number) => React.ReactNode;
}

const TableBody: React.FC<TableBodyProps> = ({
  rows,
  columns,
  onScroll,
  rowClicked,
  onRowClick,
  rowKey = "id",
  getRowActions,
  rowClickedKey,
  renderRowNestedChildren
}) => {

  const [openRowIndex, setOpenRowIndex] = useState<number | null>(null);

  const handleToggleRow = useCallback((rowIndex: number) => {
    setOpenRowIndex((prev) => prev === rowIndex ? null : rowIndex);
  }, [openRowIndex]);

  return (
    <div className="table-bottom">
      <div onScroll={onScroll} className="table-info">
        {/*{totals ? (*/}
        {/*  <TableRow key="totals">*/}
        {/*    {columns.map((col) => (*/}
        {/*      <TableCell key={col.dataKey}>TOTAL</TableCell>*/}
        {/*    ))}*/}
        {/*  </TableRow>*/}
        {/*) : null}*/}
        {rows?.map((row, index) => {
          return (
            <TableRow
              rowClicked={rowClicked}
              key={row[rowKey] || generateKey(index)}
              actions={getRowActions?.(row, index)} // TODO: optimize if needed
              onClick={() => onRowClick(row, index)}
              rowClickedKey={row[rowClickedKey]}
              handleOpenRow={() => handleToggleRow(index)}
              isOpenNestedChildren={openRowIndex === index}
              nestedChildren={renderRowNestedChildren?.(row, index)}
            >
              {columns?.map((col) => {
                return col.hideRow ? null : (
                  <TableCell
                    key={col.dataKey}
                    hasTooltip={col.hasTooltip}
                    tooltipDirection={rows.length - 1 === index ? TooltipDirection.topRight : col.tooltipDirection}
                  >
                    {col.colRenderer?.(col.formatter?.(row[col.dataKey]) || row[col.dataKey], row, index) || (
                        <>
                          <p
                            className="table-txt"
                            title={col.formatter?.(row[col.dataKey]) || row[col.dataKey]}
                          >
                            {col.formatter?.(row[col.dataKey]) || `${row[col.dataKey] ?? "-"}`}
                          </p>
                          {/*/!*ToDo: where you need to use the tooltip, on its parent element you need to add 'has-tooltip' class*!/*/}

                          {/*/!*ToDo: for tooltip positioning on 'tooltip-wrp' need to add 'bottom-right','bottom-left','top-right', 'top-left'*!/*/}
                          {/*<div className="tooltip-wrp">*/}
                          {/*  <div className="tooltip-wrp-inner">*/}
                          {/*    <p className="tooltip-wrp-info">*/}
                          {/*      The old clock on the mantelpiece ticked slowly,*/}
                          {/*      its rhythmic sound a comforting counterpoint to the*/}
                          {/*    </p>*/}
                          {/*  </div>*/}
                          {/*</div>*/}
                        </>
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </div>
    </div>
  );
};

export default memo(TableBody);
